import { render, staticRenderFns } from "./Misc.vue?vue&type=template&id=31791b2b&"
import script from "./Misc.vue?vue&type=script&lang=js&"
export * from "./Misc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports